import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { APP_VERSION, COPYRIGHT_TEXT } from '@app/shared/utilities/app-info';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  readonly copyright = COPYRIGHT_TEXT;
  readonly version = APP_VERSION;
}
